import JobPolicyDetails from '@/models/policy/JobPolicyDetails'
import { IPolicyState } from './interfaces/policy-state'

export default class PolicyState implements IPolicyState {
  public jobPolicyDetails: JobPolicyDetails = new JobPolicyDetails()
}
